import React from 'react';
import ReactDOM from 'react-dom';
import { AzureAD } from 'react-aad-msal';
import App from './App';
import Login from './pages/Login';
import { Provider } from 'react-redux';
import { CircularProgress, Grid } from '@material-ui/core';
import { rootReducerMSAL } from './store/msalRedux';
import { Store } from './store';
import { cacheAdapterEnhancer, throttleAdapterEnhancer } from 'axios-extensions';
import axios, { AxiosAdapter } from 'axios';
import { setupCache } from 'axios-cache-adapter';
import { authProvider } from './services/authProvider';
import { createRoot } from 'react-dom/client';

localStorage.removeItem("RegisterUserAfterLogin");

let ClearSession = false;
if (localStorage) {
    let msalerror = localStorage.getItem("msal.login.error");

    if (msalerror && msalerror.indexOf("Seamless single sign") >= 0) {
        ClearSession = true;
        localStorage && localStorage.clear();
    }
}
sessionStorage.setItem("autenticated", 'true')
const container = document.getElementById('root');
const root = createRoot(container!)

root.render(<Provider store={Store}>
    {
        <AzureAD provider={authProvider.providerMSal} reduxStore={Store} >
            {
                (authentication: any) => {

                    if (authentication.authenticationState === "Unauthenticated") {
                        return <Login />;
                    }
                    else if (authentication.authenticationState === "Authenticated") {
                        if (authentication.accountInfo != null && authentication.accountInfo.jwtAccessToken !== undefined) {

                            authProvider.GetTokenHH(authentication.accountInfo);

                            if (authentication.accountInfo.account.userName.includes("@paqueta") && !window.location.href.includes('heyho4.processoronline.com.br')) {
                                window.location.href = 'https://heyho-classico.processoronline.com.br/'
                            }

                            return <App />;
                        }
                        else if (authentication.accountInfo.jwtAccessToken == undefined) {
                            authProvider.GetAccessToken()
                        }
                    }

                    return (
                        <Grid container justifyContent="center" alignItems="center">
                            <CircularProgress />
                        </Grid>
                    );
                }
            }
        </AzureAD>
    }
</Provider>
);